const DEVICE_ID_STORAGE_KEY = "flowlabs_device_id";
const SESSION_ID_STORAGE_KEY = "flowlabs_session_id";

function generateId(): string {
  // `crypto.randomUUID()` is supported in modern browsers; fall back just in case.
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

function getOrCreateId(storage: Storage, key: string): string {
  const existing = storage.getItem(key);
  if (existing) return existing;

  const created = generateId();
  storage.setItem(key, created);
  return created;
}

/**
 * Returns stable identifiers to attach to Sentry events:
 * - deviceId: persists across browser restarts (localStorage)
 * - sessionId: changes per tab session (sessionStorage)
 */
export function getClientIdentifiers(): { deviceId: string; sessionId: string } {
  if (typeof window === "undefined") {
    return { deviceId: "server", sessionId: "server" };
  }

  return {
    deviceId: getOrCreateId(window.localStorage, DEVICE_ID_STORAGE_KEY),
    sessionId: getOrCreateId(window.sessionStorage, SESSION_ID_STORAGE_KEY),
  };
}



